import request from '@/utils/request'

// ==================== 系统设置 ====================

// 获取系统设置
export function getSettings(params) {
  return request({
    url: '/my.setting_controller/getSettings',
    method: 'get',
    params
  })
}

// 保存系统设置
export function saveSettings(data) {
  return request({
    url: '/my.setting_controller/saveSettings',
    method: 'post',
    data
  })
}

// 清除系统缓存
export function clearCache() {
  return request({
    url: '/my.setting_controller/clearCache',
    method: 'post'
  })
}

// 发送测试邮件
export function testEmail(data) {
  return request({
    url: '/my.setting_controller/testEmail',
    method: 'post',
    data
  })
}

// 发送测试短信
export function testSms(data) {
  return request({
    url: '/my.setting_controller/testSms',
    method: 'post',
    data
  })
}

// 获取系统信息
export function getSystemInfo() {
  return request({
    url: '/my.setting_controller/getSystemInfo',
    method: 'get'
  })
}
